import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { WifiOff, RefreshCw, Database, ShieldCheck } from "lucide-react";

const ICONS = [WifiOff, RefreshCw, Database, ShieldCheck];

export default function AtlasOffline() {
  const { t, messages } = useI18n();
  const items = messages?.offline?.items || [];
  return (
    <section
      id="modo-offline"
      data-testid="atlas-offline"
      className="py-16 lg:py-24 bg-slate-900 text-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(circle at 20% 0%, rgba(107,70,193,0.25), transparent 40%), radial-gradient(circle at 80% 80%, rgba(56,189,248,0.18), transparent 45%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-sky-300 uppercase tracking-[0.18em] text-xs font-bold">
          <WifiOff size={14} />
          <span>{t("offline.badge")}</span>
        </div>
        <h2
          data-testid="offline-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold max-w-3xl"
        >
          {t("offline.titleA")}{" "}
          <span className="text-sky-300">{t("offline.titleB")}</span>
        </h2>
        <p className="mt-3 text-slate-300 text-base sm:text-lg max-w-2xl">
          {t("offline.subtitle")}
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`offline-card-${i}`}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 transition-all hover:-translate-y-0.5 hover:bg-white/10 hover:border-sky-300/40"
              >
                <div className="h-12 w-12 rounded-xl bg-sky-400/15 text-sky-300 flex items-center justify-center">
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <h3 className="mt-5 font-display font-bold text-white text-lg leading-snug">
                  {it.title}
                </h3>
                <p className="mt-2 text-slate-300 text-sm leading-relaxed">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
